/*
|--------------------------------------------------------------------------
| Comments
|--------------------------------------------------------------------------
*/
/**
 * Functionality for comments
 * @namespace
 */
__gh__webApp.comments.viafoura = {
	/**
	 * Initialize
	 */
	"init": function(){
		this.loadLibrary();
		this.onLoad();
	},
	
	
	/**
	 * Load library
	 */
	"loadLibrary": function(){
		  (function (v, s) {
		    v.type = 'text/javascript';
		    v.async = !0;
		    v.src = '//cdn.viafoura.net/vf.js';
		    s.parentNode.insertBefore(v, s);
		  }(document.createElement('script'), document.getElementsByTagName('script')[0]));
	},
	
	
	/**
	 * Reset
	 */
	"reset":function(){
		// add third party callbacks here
		if (typeof viafoura !== 'undefined'){
			viafoura.poll();
		}
	},
	
	
	/**
	 * Run after the viafoura object is ready.
	 */
	"onLoad": function(){
		var thisObject = __gh__webApp.comments.viafoura;
		window.vfAsyncInit = function(){
		    // viafoura object is available
		    window.viafoura.ready(function(){
				thisObject.moveTermsOfServiceLink();
			});
		};
	},
	
	
	/**
	 * Moves the terms of service link under the Submit button for comments
	 */
	"moveTermsOfServiceLink": function(){
		if (typeof window.viafoura == 'undefined'){ return; }
    	
    	window.viafoura.subscribe('onCommentingThread', function (page) {
	    	
	    	var $termsLinks = $('.viafoura > .vf-terms-of-service');
	    	if (!$termsLinks.length) { return; }
	    	
	    	$termsLinks.each(function(){
		    	var $viafoura	= $(this).parent();
		    		widgetId 	= $viafoura.attr("id");
		    	$(this).insertAfter("#"+ widgetId +" .vf-comment-controls");
	    	});
	    			
		});
	}
};